export default __webpack_public_path__ + "static/media/map_3840px_prog.5218e6b4.jpg";